import React from 'react';
import { useSelector } from 'react-redux';
import { IS_PAID_B2B_TARIFF } from 'reactApp/appHelpers/configHelpers';
import { cloudOverquotaClamp } from 'reactApp/appHelpers/featuresHelpers/features/cloudOverquotaClamp';
import { enableB2BOverquotaFlow } from 'reactApp/appHelpers/featuresHelpers/features/enableB2BOverquotaFlow';
import { includeFreeUsersInB2BOverquota } from 'reactApp/appHelpers/featuresHelpers/features/includeFreeUsersInB2BOverquota';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { B2BOverquotaWarningInformer } from 'reactApp/ui/B2BOverquotaWarningInformer/B2BOverquotaWarningInformer';

export const useCommonInformers = () => {
    const isNearOverquota = useSelector(UserQuotaSelectors.isAlmostFull);
    const isB2BUserWithOverquotaClamp = (includeFreeUsersInB2BOverquota && !IS_PAID_B2B_TARIFF) || cloudOverquotaClamp;

    const shouldShowB2BOverquotaWarning = enableB2BOverquotaFlow && isNearOverquota && isB2BUserWithOverquotaClamp;

    if (shouldShowB2BOverquotaWarning) {
        return <B2BOverquotaWarningInformer />;
    }

    return null;
};
